<template>
  <div class="modal__content-inner">
    <div class="modal__head">
      <h3 class="modal__title">{{title}}</h3>
      <button @click.prevent="onBtnCloseClick"
              class="modal-edit-data__close  base-btn">
        <BaseSvg name="ico-close" width="1rem" height="1rem"/>
      </button>
    </div>
    <OverlayScrollbarsComponent v-if="message" class="modal__scroll-wrap">
      <div class="modal__main  text">
        <p>{{message}}</p>
      </div>
    </OverlayScrollbarsComponent>
    <div class="modal__footer">
      <button v-if="typeof this.callBack === 'function'"
              @click.prevent="onBtnSuccessClick"
              class="modal__btn  base-btn  base-btn--blue">
        <span>{{btnText}}</span>
      </button>
      <button @click.prevent="onBtnCloseClick"
              class="modal__btn  base-btn  base-btn--grey-blue">
        <span>{{$tGlobal('Close')}}</span>
      </button>
    </div>
  </div>
</template>

<script>
  import 'overlayscrollbars/css/OverlayScrollbars.css'
  import {OverlayScrollbarsComponent} from 'overlayscrollbars-vue'

  export default {
    components: {
      OverlayScrollbarsComponent
    },
    props: {
      title: {
        type: String,
        default: 'Oops!'
      },
      message: {
        type: String
      },
      btnText: {
        type: String,
        default: 'Ok'
      },
      callBack: Function,
    },
    methods: {
      onBtnCloseClick() {
        this.$vModal.close('warning')
      },
      onBtnSuccessClick() {
        if (typeof this.callBack === 'function') {
          this.callBack()
        }

        this.$vModal.close('warning')
      }
    }
  }
</script>

<style lang="less">

</style>
